// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3N0VK","log":"ModalInventoryLogs_log__rQe_3","date":"ModalInventoryLogs_date__TS1i_","userName":"ModalInventoryLogs_userName__36r5B"};